import { render, staticRenderFns } from "./girl-icon.vue?vue&type=template&id=bfd071b8"
import script from "./girl-icon.vue?vue&type=script&lang=js"
export * from "./girl-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports